/**
 * Product switches for this app. Set a flag to true to turn that feature back on.
 * Landing does not import from webApp, so the app has its own copy of these flags.
 */

/** When false, the landing host does not load the tracker iframe. */
export const CUSTOM_ANALYTICS_ENABLED = false;

/** When false, the cookie consent bar is not shown. */
export const COOKIE_BANNER_ENABLED = false;

/** When false, the Google tag script is not loaded. */
export const GOOGLE_TAG_ENABLED = false;
